import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl} from "@angular/forms";

@Component({
    selector: 'app-fillable-text-editor',
    templateUrl: './fillable-text-editor.component.html',
    styleUrls: ['./fillable-text-editor.component.scss'],
})
export class FillableTextEditorComponent implements OnInit {

    editor: FillableTextEditor;

    @Input() control: AbstractControl;

    constructor() { }

    ngOnInit() {
        this.editor = new FillableTextEditor(this.control);
        if(this.control.value && this.control.value.length > 0){
            const value = this.control.value;
            const segmentStrings = value.replace(/{@}/g, "||{@}||").split("||");
            console.log('segmentString: ', segmentStrings);
            const segments = segmentStrings.map(str => {
                const isField = str === "{@}";
                if(str.includes('<br>')){
                    const arr = str.split('<br>');
                    let segments = [];
                    segments.push(new TextSegment(this.editor, arr[0],false))
                    for (let i = 1; i < arr.length; i++) {
                        const seg = new TextSegment(this.editor, arr[i],false);
                        seg.linebreak = true;
                        segments.push(seg);

                    }
                    return segments;
                } else {
                    return new TextSegment(this.editor, isField ? "campo a completar" : str, isField);
                }
            }).flat();
            this.editor.segments = segments;
        }
    }

    onEnterKeyDown(){
        document.execCommand('insertHTML', false, '<br>');
        return false;
    }

}

export class FillableTextEditor {
    private static _nextID: number = 0;
    segments: TextSegment[] = [new TextSegment(this, '')];
    selected: TextSegment;
    control: AbstractControl;

    constructor(control: AbstractControl){
        this.control = control;
    }

    static get nextID(): number {
        this._nextID++;
        return this._nextID
    }

    addField(){
        this.selected.addField();
    }

    onClick(){
        if(this.segments.length === 1){
            this.firstSegment.focusAndSetCaretAtEnd();
        }
    }


    get lastSegment(): TextSegment {
        return this.segments[this.segments.length-1]
    }

    get firstSegment(): TextSegment {
        return this.segments[0]
    }

    addSegment(position: number, e: TextSegment){
        this.segments.splice(position, 0, e);
    }

    getSegmentAfter(e: TextSegment):  TextSegment{
        if(e.indexInParent < this.segments.length - 1){
            return this.segments[e.indexInParent + 1];
        } else {
            return null;
        }
    }

    getSegmentBefore(e: TextSegment): TextSegment{
        if(e.indexInParent > 0){
            return this.segments[e.indexInParent - 1];
        } else {
            return null;
        }
    }

    getSegmentNotFieldAfter(e: TextSegment): TextSegment{
        let s = this.getSegmentAfter(e);
        while (s != null && s.isField){
            s = this.getSegmentAfter(s);
        }
        console.log(s.value);
        return s;
    }

    getSegmentNotFieldBefore(e: TextSegment): TextSegment{
        let s = this.getSegmentBefore(e);
        while (s != null && s.isField){
            s = this.getSegmentBefore(s);
        }
        return s;
    }

    deleteSegmentAfter(e: TextSegment){
        if(e.indexInParent < this.segments.length - 1){
            this.deleteSegment(e.indexInParent + 1);
        }
    }

    deleteSegmentBefore(e: TextSegment){
        if(e.indexInParent > 0){
            this.deleteSegment(e.indexInParent - 1);
        }
    }

    deleteSegment(position: number){
        this.segments.splice(position, 1);
    }

    generateFinalValue(){
        let values = [];
        for(let segment of this.segments){
            if(segment.linebreak){
                values.push('\n');
            }
            if(segment.isField){
                values.push(' {@} ')
            } else {
                values.push(segment.getNativeElement().innerHTML.replace(/&nbsp;/g, " "));
            }
        }
        console.log('values: ', values);
        this.control.setValue(values.join(''));
    }

}

export class TextSegment {
    value: string;
    isField: boolean;
    id: number;
    parent: FillableTextEditor;
    cursorIsAtTheEnd = false;
    cursorIsAtTheStart = false;
    currentCaretPosition: number;
    linebreak = false;
    constructor(parent: FillableTextEditor, value: string, isField: boolean = false){
        this.isField = isField;
        this.value = value;
        this.parent = parent;
        this.id = FillableTextEditor.nextID;
    }

    refreshValue(){
        this.value = document.getElementById(this.id + '').innerHTML
    }

    getNativeElement(){
        return document.getElementById(this.id+'');
    }

    getCaretPosition() {
        let _range = document.getSelection().getRangeAt(0);
        let range = _range.cloneRange();
        range.selectNodeContents(document.getElementById(this.id + ''));
        range.setEnd(_range.endContainer, _range.endOffset);
        return range.toString().length;
    }

    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const text = event.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
    }

    setCursorAt(position: number = this.value.length) {
        setTimeout(() => {
            try{
                const el = document.getElementById(this.id + '');
                const range = document.createRange();
                const sel = window.getSelection();
                let node = el.childNodes[el.childNodes.length - 1];
                if(node == undefined){
                    node = el;
                }
                range.setStart(node, position);
                range.setEnd(node, position);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            } catch (e) {
                console.warn('failed to set cursor position')
            }

        });
    }

    addField(){
        const position = this.getCaretPosition();
        this.refreshValue();
        this.value = this.value.replace(/&nbsp;/g, '')
        let split = [this.value.substring(0, position), this.value.substring(position, this.value.length)];
        this.value = split[0];
        const newSegment = new TextSegment(this.parent, split[1], false);
        const field = new TextSegment(this.parent, 'campo a completar', true );
        this.addSegmentNext(field);
        field.addSegmentNext(newSegment)
        newSegment.focus();
    }

    focus(){
        setTimeout(() => {
            this.getNativeElement().focus();
        })
    }

    onEnter(){
        this.refreshValue();
        const split = this.value.split('<br>');
        console.log(split);

        const empty = new TextSegment(this.parent, '', false);
        empty.linebreak = true;

        this.removeBRs();

        if(split[0].length === 0){
            this.addSegmentBefore(empty);
        } else if(split[1].length === 0){
            this.addSegmentNext(empty);
            empty.focus();
        } else {
            this.value = split[0];
            const newElement = new TextSegment(this.parent, split[1], false);
            newElement.linebreak = true;
            this.addSegmentNext(newElement);
            newElement.focus();
        }



    }

    onFocus(){
        this.parent.selected = this;
    }

    onFocusOut(){
        setTimeout(() => {
            if(this.parent.selected.equals(this)){
                this.parent.selected = null;
            }
        }, 200)
        this.parent.generateFinalValue();
    }

    removeBRs(){
        console.log('before:', this.value);
        this.value = this.value.replace(/<br>/g, '');
        console.log('after:', this.value);
        this.getNativeElement().innerHTML = this.value;
    }

    onDelete(){
        const currentCaret = this.getCaretPosition();
        this.refreshValue();
        const segmentAfter = this.parent.getSegmentAfter(this);
        if(this.cursorIsAtTheEnd && currentCaret === this.value.length && segmentAfter){
            if(segmentAfter.isField){
                this.parent.deleteSegmentAfter(this);
            } else {
                this.suicide();
                segmentAfter.focusAndSetCaretAtEnd()
            }
        } else {
            this.setCursorAt(currentCaret);
        }
        this.checkCursor();
    }

    onArrowLeft(){
        if(this.cursorIsAtTheStart){
            this.parent.getSegmentNotFieldBefore(this).focusAndSetCaretAtEnd();
        }
        this.checkCursor();
    }

    onArrowRight(){
        if(this.cursorIsAtTheEnd){
            this.parent.getSegmentNotFieldAfter(this).focus();
        }
        this.checkCursor();
    }

    checkCursor(){
        const currentCaret = this.getCaretPosition();
        this.cursorIsAtTheEnd = currentCaret === this.getNativeElement().innerText.length
        this.cursorIsAtTheStart = currentCaret === 0;
        this.currentCaretPosition = currentCaret;

    }

    onArrowUp(){
        const cursorAfter = this.getCaretPosition();
        console.log('cursorAfter: ', cursorAfter);
        console.log('currentCursor: ', this.currentCaretPosition);
        if(this.currentCaretPosition === cursorAfter && !this.isFirst){
            this.parent.segments[this.indexInParent - 1].focusAndSetCaretAtEnd();
        }
        this.checkCursor();
        return false;
    }

    onArrowDown(){
        const cursorAfter = this.getCaretPosition();
        console.log('cursorAfter: ', cursorAfter);
        console.log('currentCursor: ', this.currentCaretPosition);
        if(this.currentCaretPosition === cursorAfter && !this.isLast){
            this.parent.segments[this.indexInParent + 1].focusAndSetCaretAtEnd();
        }
        this.checkCursor();
        return false;
    }

    onBackspace(){
        const currentCaret = this.getCaretPosition();
        const segmentBefore = this.parent.getSegmentBefore(this);
        if(this.cursorIsAtTheStart && currentCaret === 0  && segmentBefore){
            if(segmentBefore.isField){
                this.parent.deleteSegmentBefore(this);
            } else {
                this.refreshValue();
                if(this.value.length === 0){
                    this.suicide();
                    segmentBefore.focusAndSetCaretAtEnd()
                } else {
                    this.parent.getSegmentBefore(this).focusAndSetCaretAtEnd();
                }
            }
        }
        this.checkCursor();
    }

    suicide(){
        this.parent.deleteSegment(this.indexInParent);
    }

    addSegmentNext(e: TextSegment) {
        this.parent.addSegment(this.indexInParent+1, e)
    }

    addSegmentBefore(e: TextSegment){
        this.parent.addSegment(this.indexInParent, e)
    }

    equals(o: TextSegment): boolean {
        return this.id === o.id;
    }

    get indexInParent(): number {
        return this.parent.segments.indexOf(this);
    }

    get isFirst(): boolean {
        return this.indexInParent === 0;
    }

    get isLast(): boolean {
        return this.indexInParent === this.parent.segments.length - 1;
    }

    focusAndSetCaretAtEnd(){
        this.focus();
        this.setCursorAt(this.getNativeElement().innerText.length);
    }

}



// import {
//     ChangeDetectionStrategy,
//     ChangeDetectorRef,
//     Component,
//     ElementRef, HostListener, Input,
//     OnInit,
//     SecurityContext,
//     ViewChild,
// } from '@angular/core';
// import * as htmlparser2 from 'htmlparser2';
// import {AbstractControl} from '@angular/forms';
//
// @Component({
//     selector: 'app-fillable-text-editor',
//     templateUrl: './fillable-text-editor.component.html',
//     styleUrls: ['./fillable-text-editor.component.scss'],
//     changeDetection: ChangeDetectionStrategy.OnPush
// })
// export class FillableTextEditorComponent {
//
//     /* el div con contenteditable donde escribis */
//     @ViewChild('input') input: ElementRef;
//     @Input() control: AbstractControl;
//
//     /* el valor de lo que escribis. Se actualiza cuando sacas el foco del input */
//     value = '';
//     caretPosition: number;
//
//     /* el interval que va actualizando la posicion del cursor */
//     updateCaretInterval: any;
//
//     constructor(private cd: ChangeDetectorRef) {
//         /* Detectar el cambio de pestaña en el navegador
//         window.addEventListener("focus", () =>{
//             console.log("Aca tengo que restear el cursor");
//         })
//         */
//     }
//
//     /*detecta en que posicion esta el caret (cursor). Hay que hacer un detach del change detector para no
//     * perder el innerHTML, que todavia no entro en this.value */
//     updateCaret(e: MouseEvent) {
//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();
//         this.cd.detach();
//
//         /*como el usuario puede dejar el mouse sobre el boton y seguir escribiendo, vamos actualizando
//         * el cursor a cada rato hasta que salga del boton*/
//         this.updateCaretInterval = setInterval(() => this.caretPosition = getCaretPosition(this.input.nativeElement), 300);
//
//     }
//
//     onButtonMouseLeave(){
//         clearInterval(this.updateCaretInterval);
//         this.onFocusOut();
//
//     }
//
//     /* te da lo que escribiste en el input, tal cual se ve para el usuario */
//     getStringValue(): string {
//         return this.input.nativeElement.innerText.toString();
//     }
//
//     /* te da lo que escribiste en el input, pero los campos completables son el elemento HTML
//     * tambien los saltos de linea son <br> y los espacios problablemente sean &nbsp; */
//     getHTMLValue(): string {
//         return this.input.nativeElement.innerHTML.toString();
//     }
//
//
//     addField(e: Event) {
//         /* seguramente el change detector esta desatachado por el updateCaret, asi que lo re-attacho */
//         this.cd.reattach();
//         this.input.nativeElement.focus();
//         let value = this.getStringValue();
//         /* como el caret no cuenta los saltos de linea, los cuento a mano y se lo sumo a la posicion */
//         const lineBreaks = (value.substring(0, this.caretPosition).match(/\n/g) || []).length;
//
//         /* el caret cuenta posiciones sobre el texto como se ve en el input. Por eso usamos el getStringValue,
//         * para cortar el texto en la posicion del cursor. Despues volvemos a remplazar el 'campo a completar'
//         * por el html correspondiente. Al final, juntamos las dos mitades con un nuevo campo en el medio */
//         let value1 = value.substring(0, this.caretPosition + lineBreaks);
//         let value2 = value.substring(this.caretPosition + lineBreaks, value.length);
//         value1 = value1.split(placeholder).join(campoACompletar);
//         value2 = value2.split(placeholder).join(campoACompletar);
//         this.value = value1 + ' ' + campoACompletar + ' ' + value2;
//         this.value = this.value.replace(/\n/g, '<br>');
//         // this.value = this.getHTMLValue() + campoACompletar;
//         this.cd.markForCheck();
//
//         /* espera a que se apliquen los cambios en la vista y movemos el cursor al final del
//         * texto del input */
//         setTimeout(() => {
//             const el = this.input.nativeElement;
//             const range = document.createRange();
//             const sel = window.getSelection();
//             range.setStart(el.childNodes[el.childNodes.length - 1], 0);
//             range.setEnd(el.childNodes[el.childNodes.length - 1], 0);
//             range.collapse(true);
//             sel.removeAllRanges();
//             sel.addRange(range);
//         })
//
//     }
//
//
//     /* cuando sale de foco, actualiza el valor que maneja el formControl que viene de afuera */
//     onFocusOut() {
//         this.value = this.getHTMLValue();
//         /* limpia los saltos de linea y espacios */
//         const value = this.value.replace(/&nbsp;/g, ' ').replace(/<br>/g, '\n');
//         this.cd.markForCheck();
//
//         /*parseo todos los <span> (los campos completables) y los dejo como '{@}', que es lo que espera
//         * el resto de la aplicacion */
//         let parsed = '';
//         const parser = new htmlparser2.Parser({
//             onopentag(name, attribs) {
//                 if (name === 'span' && attribs.class === 'field replace') {
//                     parsed += ' {@} ';
//                 }
//             },
//             /* remplaza el texto comun, esquivando los 'campo a completar' que estan dentro de los <span>
//             * ya que esos tienen que ir como {@} */
//             ontext(data: string): void {
//                 if (data !== placeholder) parsed += data;
//             }
//         });
//         parser.write(value);
//         parser.end();
//         this.control.setValue(parsed);
//     }
//
//
// }
//
// /* te devuelve la posicion del cursor dentro del elemento */
// function getCaretPosition(element) {
//     let _range = document.getSelection().getRangeAt(0);
//     let range = _range.cloneRange();
//     range.selectNodeContents(element);
//     range.setEnd(_range.endContainer, _range.endOffset);
//     return range.toString().length;
// }
//
// const placeholder = 'campo a completar';
//
// /* los estilos hay que ponerlos en linea por el ViewEncapsulation */
// const fieldStyle = 'border-bottom: 1px solid #bdbdbd; ' +
//     '  background-color: #e8e8e8; ' +
//     '  cursor: pointer; ' +
//     '  padding: 1px 3px; ' +
//     '  display: inline-block; ' +
//     '  border-radius: 5px; ' +
//     '  box-decoration-break: clone; ' +
//     '  transition: all 0.3s ease-out;';
//
// const campoACompletar = `<span contentEditable="false" class="field replace" style="${fieldStyle}" >${placeholder}</span>`;



// WEBPACK FOOTER //
// ./src/app/forms/components/fillable-text-editor/fillable-text-editor.component.ts